import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, SERVICE_LIST } from "@/data/services";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-elevated border-t border-line mt-24">
      <div className="mx-auto max-w-page px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src="/logo-icon.png"
              alt="Styne Group"
              className="h-14 w-auto"
              data-testid="footer-logo"
            />
            <div className="flex flex-col leading-none">
              <span className="font-display text-2xl font-bold tracking-wider text-ink">STYNE</span>
              <span className="font-body text-[10px] tracking-[0.4em] text-muted mt-1">GROUP</span>
            </div>
          </div>
          <p className="text-muted text-sm leading-relaxed max-w-xs">
            Premium plumbing, civil works and maintenance services for Melbourne and the Yarra Valley.
          </p>
        </div>

        <div>
          <h4 className="font-display tracking-widerx text-sm text-muted mb-5">Services</h4>
          <ul className="space-y-3">
            {SERVICE_LIST.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="text-ink hover:text-gold transition-colors text-[15px]"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {s.title}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/tools"
                className="inline-flex items-center gap-2 text-ink hover:text-gold transition-colors text-[15px]"
                data-testid="footer-tools"
              >
                Free Tools Hub
                <span className="text-[8px] tracking-widest bg-gold/15 text-gold px-1.5 py-0.5 border border-gold/30">FREE</span>
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="text-ink hover:text-gold transition-colors text-[15px]"
                data-testid="footer-pricing"
              >
                Pricing Guide
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="text-ink hover:text-gold transition-colors text-[15px]"
                data-testid="footer-gallery"
              >
                Gallery — Recent Work
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display tracking-widerx text-sm text-muted mb-5">Service Areas</h4>
          <ul className="space-y-3 text-[15px]">
            <li><Link to="/areas" className="text-ink hover:text-gold transition-colors">Melbourne Metro</Link></li>
            <li><Link to="/areas" className="text-ink hover:text-gold transition-colors">Eastern Suburbs</Link></li>
            <li><Link to="/areas" className="text-ink hover:text-gold transition-colors">Yarra Valley</Link></li>
            <li><Link to="/areas" className="text-ink hover:text-gold transition-colors">Outer East</Link></li>
            <li><Link to="/areas" className="text-ink hover:text-gold transition-colors">Bayside</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display tracking-widerx text-sm text-muted mb-5">Contact</h4>
          <ul className="space-y-4">
            <li>
              <a href={PHONE_HREF} className="flex items-start gap-3 text-ink hover:text-gold transition-colors" data-testid="footer-phone">
                <Phone size={16} className="text-gold mt-1" />
                <span>{PHONE}</span>
              </a>
            </li>
            <li>
              <a href={EMAIL_HREF} className="flex items-start gap-3 text-ink hover:text-gold transition-colors break-all" data-testid="footer-email">
                <Mail size={16} className="text-gold mt-1 flex-shrink-0" />
                <span>{EMAIL}</span>
              </a>
            </li>
            <li className="flex items-start gap-3 text-ink">
              <MapPin size={16} className="text-gold mt-1 flex-shrink-0" />
              <span>Melbourne & Yarra Valley<br /><span className="text-muted text-sm">Victoria, Australia</span></span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="mx-auto max-w-page px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-muted text-xs tracking-widerx uppercase">
            © {new Date().getFullYear()} Styne Group · All rights reserved
          </p>
          <p className="text-muted text-xs tracking-widerx uppercase">
            Licensed · Insured · Warranty Backed
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
